import { USER_LOGOUT_CLEAR } from 'constants/ActionTypes';
import { FROM, SORT, APPOINTMENT_STATUS, TO, APPOINTMENT_TYPE } from 'constants/FilterConstants';
import * as actionTypes from 'modules/appointments/actionTypes';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import { createReducer } from 'utils/ReduxUtils';

import { getPersistedFilters } from '../../../../../services/StateLoader';

const persistedFilters = getPersistedFilters()?.filters?.appointments ?? {};

const emptyState = {
  [APPOINTMENT_STATUS]: [],
  [SORT]: 'date,desc',
  // Those values are set to null to have them overridden in the selector
  // This allows us to use the dealer timezone that is unknown at this point
  [FROM]: null,
  [TO]: null,
  [APPOINTMENT_TYPE]: null,
};

const filterAdapter = filterSliceAdapter(emptyState, persistedFilters);

export default createReducer(filterAdapter.getInitialState(), {
  [actionTypes.SET_APPOINTMENT_FILTER]: filterAdapter.setFilter,
  [actionTypes.SET_APPOINTMENT_FILTERS]: filterAdapter.setFilters,
  [actionTypes.CLEAR_APPOINTMENT_FILTERS]: filterAdapter.resetFilters,
  [actionTypes.REMOVE_APPOINTMENT_FILTER]: filterAdapter.removeFilter,
  [USER_LOGOUT_CLEAR]: filterAdapter.resetFilters,
});
